// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .root-user-side-bar{
        height: 100%;
        z-index: 0;
        width: 12vw;
        padding-top: 20px;
        box-sizing: border-box;
        background-color: rgba(155, 30, 30, 0.952);
        display: block;
    }
    .root-user-side-bar-button-container{
        display: block;
        color: transparent;
        background-color: transparent;
        text-align: left;
        padding-left: 18px;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .root-user-side-bar-button-container img{
        height: 25px;
    }
    .root-user-side-bar-button-container button{
        border: none;
        margin-left: 2px;
        padding: 10px 5px;
        font-size: 16px;
        cursor: inherit;
        color: white;
        background-color: transparent;
    }
}
@media screen and (max-width:949px){
    .root-user-side-bar{
        position: absolute;
        z-index: 1;
        width: 60vw;
        height: 100%;
        background-color: rgba(155, 30, 30, 0.952);
        display: none;
    }
    .root-user-side-bar.show{
        display: block;
    }
    .root-user-side-bar-button-container{
        display: block;
        color: transparent;
        background-color: transparent;
        text-align: left;
        padding-left: 18px;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .root-user-side-bar-button-container img{
        height: 25px;
    }
    .root-user-side-bar-button-container button{
        border: none;
        margin-left: 2px;
        padding: 10px 5px;
        font-size: 16px;
        cursor: inherit;
        color: white;
        background-color: transparent;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/sidebar_styles/RootUserSideBar.css"],"names":[],"mappings":"AAAA;IACI;QACI,YAAY;QACZ,UAAU;QACV,WAAW;QACX,iBAAiB;QACjB,sBAAsB;QACtB,0CAA0C;QAC1C,cAAc;IAClB;IACA;QACI,cAAc;QACd,kBAAkB;QAClB,6BAA6B;QAC7B,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf,eAAe;QACf,YAAY;QACZ,6BAA6B;IACjC;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,YAAY;QACZ,0CAA0C;QAC1C,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;QACd,kBAAkB;QAClB,6BAA6B;QAC7B,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf,eAAe;QACf,YAAY;QACZ,6BAA6B;IACjC;AACJ","sourcesContent":["@media screen and (min-width:950px){\n    .root-user-side-bar{\n        height: 100%;\n        z-index: 0;\n        width: 12vw;\n        padding-top: 20px;\n        box-sizing: border-box;\n        background-color: rgba(155, 30, 30, 0.952);\n        display: block;\n    }\n    .root-user-side-bar-button-container{\n        display: block;\n        color: transparent;\n        background-color: transparent;\n        text-align: left;\n        padding-left: 18px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n    }\n    .root-user-side-bar-button-container img{\n        height: 25px;\n    }\n    .root-user-side-bar-button-container button{\n        border: none;\n        margin-left: 2px;\n        padding: 10px 5px;\n        font-size: 16px;\n        cursor: inherit;\n        color: white;\n        background-color: transparent;\n    }\n}\n@media screen and (max-width:949px){\n    .root-user-side-bar{\n        position: absolute;\n        z-index: 1;\n        width: 60vw;\n        height: 100%;\n        background-color: rgba(155, 30, 30, 0.952);\n        display: none;\n    }\n    .root-user-side-bar.show{\n        display: block;\n    }\n    .root-user-side-bar-button-container{\n        display: block;\n        color: transparent;\n        background-color: transparent;\n        text-align: left;\n        padding-left: 18px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n    }\n    .root-user-side-bar-button-container img{\n        height: 25px;\n    }\n    .root-user-side-bar-button-container button{\n        border: none;\n        margin-left: 2px;\n        padding: 10px 5px;\n        font-size: 16px;\n        cursor: inherit;\n        color: white;\n        background-color: transparent;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
